import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Links from "./links";
import Headings from "./Headings";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Terms from "./terms";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const Footer = () => {
  const data = {
    headings: {
      heading1: "Product",
      heading2: "Company",
      heading3: "Support",
    },
    Products: {
      Title1: "Features",
      Title2: "Pricing",
      Title3: "Case Studies",
      Title4: "Reviews",
      Title5: "Updates",
    },
    Company: {
      Title1: "About ",
      Title2: "Contact us",
      Title3: "Careers",
      Title4: "Culture",
      Title5: "Blog",
    },
    Support: {
      Title1: "Getting Started",
      Title2: "Help Center",
      Title3: "Server Status",
      Title4: "Report a bug",
      Title5: "Chat Report",
    },
    Contact: {
      Title1: "contact@company.com",
      Title2: "(414) 687 - 5892",
      Title3: "794 Mcallister StSan Francisco, 94102",
    },
    Terms: {
      Title1: "All Rights Reserved",
      Title2: "Terms and Conditions",
      Title3: "Privacy Policy",
    },
  };
  return (
    <>
      <Box
        sx={{
          paddingX: { lg: "113px", xs: "10px" },
          paddingY: "30px",
          backgroundColor: "blue.main",
        }}
      >
        <Grid container>
          <Grid item lg={4} xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: { lg: "start", xs: "center" },
              }}
            >
              <Typography fontWeight={"bold"} variant="h3" color={"white.main"}>
                {" "}
                T-SHIRT
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: { lg: "start", xs: "center" },
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  width: "270px",
                  textAlign: { lg: "start", xs: "center" },
                  fontSize: "17px",
                  lineHeight: "2.0rem",
                  color: "grey.main",
                  wordWrap: "break-word",
                  marginTop: "24px",
                }}
              >
                Lorem ipsum dolor sit amet consectetur adipiscing elit aliquam
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: { lg: "start", xs: "center" },
              }}
            >
              <Box
                sx={{
                  borderRadius: "50px",
                  backgroundColor: "blue.main",
                  color: "white.main",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              >
                <FacebookIcon style={{ fontSize: "20px" }} />
              </Box>
              <Box
                sx={{
                  borderRadius: "50px",
                  backgroundColor: "blue.main",
                  color: "white.main",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              >
                <YouTubeIcon style={{ fontSize: "20px" }} />
              </Box>
              <Box
                sx={{
                  borderRadius: "50px",
                  backgroundColor: "blue.main",
                  color: "white.main",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              >
                <WhatsAppIcon style={{ fontSize: "20px" }} />
              </Box>
              <Box
                sx={{
                  borderRadius: "50px",
                  backgroundColor: "blue.main",
                  color: "white.main",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              >
                <TwitterIcon style={{ fontSize: "20px" }} />
              </Box>
              <Box
                sx={{
                  borderRadius: "50px",
                  backgroundColor: "blue.main",
                  color: "white.main",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              >
                <LinkedInIcon style={{ fontSize: "20px" }} />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            lg={8}
            xs={12}
            display={"flex"}
            flexDirection={{ md: "row", xs: "column" }}
            marginBottom={{ md: "0xp", xs: "20px" }}
            justifyContent={{ lg: "space-between", xs: "space-around" }}
          >
            <Box>
              <Headings data={data.headings.heading1} />
              <Links data={data.Products.Title1} />
              <Links data={data.Products.Title2} />
              <Links data={data.Products.Title3} />
              <Links data={data.Products.Title4} />
              <Links data={data.Products.Title5} />
            </Box>
            <Box>
              <Headings data={data.headings.heading3} />
              <Links data={data.Company.Title1} />
              <Links data={data.Company.Title2} />
              <Links data={data.Company.Title3} />
              <Links data={data.Company.Title4} />
              <Links data={data.Company.Title5} />
            </Box>
            <Box>
              <Headings data={data.headings.heading2} />
              <Links data={data.Support.Title1} />
              <Links data={data.Support.Title2} />
              <Links data={data.Support.Title3} />
              <Links data={data.Support.Title4} />
              <Links data={data.Support.Title5} />
            </Box>

            <Box>
              <Headings data={"Contact Us"} />
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: { md: "start", xs: "center" },
                  }}
                >
                  <EmailOutlinedIcon
                    sx={{
                      color: "white.main",
                      marginTop: "8px",
                      marginRight: "10px",
                    }}
                  />
                  <Links data={data.Contact.Title1} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { md: "start", xs: "center" },
                  }}
                >
                  <LocalPhoneOutlinedIcon
                    sx={{ color: "white.main",   marginTop: "8px",
                    marginRight: "10px", }}
                  />
                  <Links data={data.Contact.Title2} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { md: "start", xs: "center" },
                  }}
                >
                  <LocationOnOutlinedIcon
                    sx={{ color: "white.main",    marginTop: "8px",
                    marginRight: "10px", }}
                  />
                  <Links data={data.Contact.Title3} />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <hr style={{ color: "white.main" }} />
        <Box sx={{ marginTop: "30px" }}>
          <Grid container>
            <Grid item md={3} xs={12} order={{ md: 1, xs: 2 }}>
              <Typography
                variant={"h5"}
                sx={{
                  color: "white.main",

                  fontStyle: "Regular",
                  fontSize: "16px",

                  letterSpacing: "0.5%",
                  cursor: "pointer",
                  textAlign: { lg: "start", xs: "center" },
                  marginTop: { md: "0px", xs: "10px" },
                }}
              >
                Copyright © 2023 T-Shirt AI
              </Typography>
            </Grid>
            <Grid
              item
              md={9}
              xs={12}
              order={{ md: 2, xs: 1 }}
              sx={{
                display: "flex",
                justifyContent: { lg: "end", xs: "center" },
                alignItems: "center",
              }}
            >
              <Terms data={data.Terms.Title1} />
              <Terms data={data.Terms.Title2} underline={"underline"} />
              <Terms data={data.Terms.Title3} underline={"underline"} />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
